import * as React from 'react';
import { connect } from 'react-redux';
import { WithStyles, withStyles, } from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import { ISchedule } from '@app-types/websocket/schedule.types';
import { IFamilyMember } from '@app-types/websocket/family.types';
import CheckIcon from '@material-ui/icons/Check';
import { EditPaneStyle } from '../../EditPane.style';
import { FamilyMemberType } from '@services/family/family.constants';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import BackArrowIcon from "@material-ui/icons/ArrowBackIosRounded";

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  parentA: number | undefined;
  parentB: number | undefined;
  kids: number[];
}

interface IProps extends WithStyles<typeof EditPaneStyle> {
  family: IFamilyMember[];
  scheduleEditBase: ISchedule | undefined;
  updateBase: (schedule: ISchedule) => void;
  close: (finished:boolean) => void;
}

class Children extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    const parentA: number | undefined = props.scheduleEditBase ? props.scheduleEditBase.data.parentA : undefined;
    const parentB: number | undefined = props.scheduleEditBase ? props.scheduleEditBase.data.parentB : undefined;
    const kids: number[] = props.scheduleEditBase ? [...props.scheduleEditBase.data.children] : [];

    this.state = {
      parentA,
      parentB,
      kids,
    };
  }

  public componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    if (prevProps.scheduleEditBase !== this.props.scheduleEditBase) {
      const parentA: number | undefined = this.props.scheduleEditBase ? this.props.scheduleEditBase.data.parentA : undefined;
      const parentB: number | undefined = this.props.scheduleEditBase ? this.props.scheduleEditBase.data.parentB : undefined;
      const kids: number[] = this.props.scheduleEditBase ? [...this.props.scheduleEditBase.data.children] : [];
      this.setState({ parentA, parentB, kids });
    }
  }

  public render() {
    const { classes, family } = this.props;
    const { parentA, parentB, kids } = this.state;

    const parentOptions: number[] = this.props.scheduleEditBase
      ? [this.props.scheduleEditBase.data.parentA, this.props.scheduleEditBase.data.parentB] : [];
    const kidOptions: number[] = this.props.scheduleEditBase
      ? [...this.props.scheduleEditBase.data.children] : [];

    for (const mem of family) {
      if (mem.role === FamilyMemberType.PARENT) {
        if (!parentOptions.includes(mem.id)) {
          parentOptions.push(mem.id);
        }
      }
      else if (mem.role === FamilyMemberType.CHILD) {
        if (!kidOptions.includes(mem.id)) {
          kidOptions.push(mem.id);
        }
      }
    }

    // create parent divs
    const parents: JSX.Element[] = parentOptions.map((parent, index) => {
      let avatar: JSX.Element | undefined;
      let erased: string | undefined;
      const borderBottom: string = (index === (parentOptions.length - 1)) ? "none" : "1px solid #ccc";
      for (const mem of family) {
        if (mem.id === parent) {
          avatar = <ImgAvatar imgName={mem.avatar} color={mem.color} style={{ marginRight: '3px' }}
            imgUrl={mem.imageAvatar ? mem.avatarURL : undefined} />
          if (mem.role === FamilyMemberType.DELETED) {
            erased = "(" + tn.lang.erased + ")"
          }
          break;
        }
      }
      return (
        <div className={classes.paneAction} key={index} style={{ borderBottom }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>{avatar}{tn.familyMemberName(parent, family)}{erased}</div>
          <CheckIcon style={{ opacity: (parentA === parent || parentB === parent) ? 1 : 0 }} className={classes.checkIcon} />
        </div>)
    });

    // create kid divs
    const kidsElements: JSX.Element[] = kidOptions.map((kid, index) => {
      let avatar: JSX.Element | undefined;
      let erased: string | undefined;
      const borderBottom: string = (index === (kidOptions.length - 1)) ? "none" : "1px solid #ccc";

      for (const mem of family) {
        if (mem.id === kid) {
          avatar = <ImgAvatar imgName={mem.avatar} color={mem.color} style={{ marginRight: '3px' }}
            imgUrl={mem.imageAvatar ? mem.avatarURL : undefined} />
          if (mem.role === FamilyMemberType.DELETED) {
            erased = "(" + tn.lang.erased + ")"
          }
          break;
        }
      }

      return (
        <div className={classes.paneAction} key={index} style={{ borderBottom }} onClick={() => this.handleClickOnKid(kid)}>
          <div style={{ display: 'flex', alignItems: 'center' }}>{avatar}{tn.familyMemberName(kid, family)}{erased}</div>
          <CheckIcon style={{ opacity: (kids.includes(kid)) ? 1 : 0 }} className={classes.checkIcon} />
        </div>)
    });


    return (<>
      <div className={classes.paneOptions} >
        <Button className={classes.paneOption}  startIcon={<BackArrowIcon />} classes={{text:classes.backButton}}
          style={{ textAlign: 'start' }} onClick={() => { this.props.close(false); }}>
          {tn.lang.back}
        </Button>
        <div className={classes.paneOption} >{""}</div>
        <Button className={classes.paneOption} style={{ textAlign: 'end' }}
          disabled={parentA === undefined || parentB === undefined || kids.length === 0} onClick={() => this.execute()}>
          {tn.lang.calNext}
        </Button>
      </div>
      <div style={{ width: '100%', overflow: 'auto' }}>
        <div className={classes.headerTitle}>{tn.lang.calForKids}</div>
        <div className={classes.paneActions}>
          {kidsElements}
        </div>
        <div className={classes.headerTitle}>{tn.lang.calParents}</div>
        <div className={classes.paneActions}>
          {parents}
        </div>
        <div style={{ minHeight: '20px', width: '80%' }} />
      </div>
    </>
    );
  }

  private handleClickOnKid(kid:number) {
    if (this.state.kids.includes(kid)) {
      this.setState({kids:this.state.kids.filter((k) => k !== kid)});
    } else {
      this.setState({kids:[...this.state.kids, kid]})
    }
  }

  private execute() {
    if (this.props.scheduleEditBase) {
      const oldSched = this.props.scheduleEditBase;
      const newSchedule: ISchedule = {
        id: oldSched.id,
        lastHandover: oldSched.lastHandover,
        status: oldSched.status,
        name: oldSched.name,
        school: oldSched.school,
        data: {
          children: this.state.kids,
          parentA: oldSched.data.parentA,
          parentB: oldSched.data.parentB,
          scheduleEntriesParentA: JSON.parse(JSON.stringify(oldSched.data.scheduleEntriesParentA)),
          scheduleEntriesParentB: JSON.parse(JSON.stringify(oldSched.data.scheduleEntriesParentB)),
        }
      }
      this.props.updateBase(newSchedule);
      this.props.close(true);
    }
  }

}

function mapStateToProps(state: any) {

  return {
    family: state.family.family,
  };
}

export default connect(mapStateToProps)(withStyles(EditPaneStyle)(Children));



// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/editActions/Children/Children.tsx